import * as React from 'react';
import { Col as BCol, Row as BRow } from 'react-bootstrap';
import {
  Field,
  getFieldArray,
  getFieldColumnWidths,
  getFieldStringFromPrimitive,
  isBlank,
  Primitive,
  Row,
} from 'gossamer-unified';
import { ErrorBoundary } from '../ancillary/ErrorBoundary';
import { SubSectionSingleProps } from '../data/QuerySingle';
import { General } from '../fields/General';
import styles from './FieldBlock.module.css';

export interface DisplayFieldBlockProps {
  fieldId: string;
  field: Field;
  value: string;
}

export const DisplayFieldBlock = (props: DisplayFieldBlockProps): React.JSX.Element => (
  <BCol key={props.fieldId} {...getFieldColumnWidths(props.field)}>
    <div className={`${styles.FieldBlock} fieldBlock`}>
      <div>
        {props.field.label}
        {props.field.description && (
          <>
            &nbsp;&nbsp;<a title={props.field.description}>ⓘ</a>
          </>
        )}
      </div>
      <b>
        <General editable={false} fieldId={props.fieldId} field={props.field} value={props.value} />
      </b>
    </div>
  </BCol>
);

export interface BasicFormBlockProps {
  label: string;
  children: React.ReactNode;
}

export const BasicFormBlock = (props: BasicFormBlockProps): React.JSX.Element => (
  <div className={styles.FieldBlock}>
    <div>{props.label}</div>
    {props.children}
  </div>
);

export const Display = <T extends Row>(props: SubSectionSingleProps<T>): React.JSX.Element => {
  const rowValues = props.row as Record<string, unknown>;
  return (
    <ErrorBoundary>
      <BRow className="mb20px">
        {getFieldArray(props.entity)
          .filter(
            ([field, fieldId]: [Field, string]) =>
              field.visible !== false &&
              (!isBlank(rowValues[fieldId]) || field.showEvenIfBlank) &&
              (!props.fieldGroup || props.fieldGroup === field.fieldGroup),
          )
          .map(([field, fieldId]: [Field, string]) => (
            <DisplayFieldBlock
              key={fieldId}
              fieldId={fieldId}
              field={field}
              value={getFieldStringFromPrimitive(field.type, rowValues[fieldId] as Primitive)}
            />
          ))}
      </BRow>
    </ErrorBoundary>
  );
};
